"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditFieldFormat = EditFieldFormat;

var _tableCurrency = _interopRequireDefault(require("../fields/table-currency"));

var _TextField = _interopRequireDefault(require("@eig-builder/core-ui/TextField"));

var _react = _interopRequireDefault(require("react"));

function EditFieldFormat(params) {
  var col = params.colDef;

  if (col.currency) {
    return /*#__PURE__*/_react["default"].createElement(_tableCurrency["default"], {
      uniqueKey: params.data.unique_key.toString(),
      key: params.data.unique_key,
      value: params.value,
      onBlur: col.editFunction,
      currency: col.currency
    });
  } else {
    return /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
      ref: "field",
      id: params.data.unique_key.toString(),
      value: params.value,
      type: "text",
      onChange: col.editFunction
    });
  }
}